import React from "react";
import { motion } from "framer-motion";
import { Workflow, Users2, LineChart } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = [Workflow, Users2, LineChart];

const Why = () => {
  const { t } = useLang();
  return (
    <section id="why" className="py-24 lg:py-32 bg-[var(--ivory)]" data-testid="why-section">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <span className="overline" data-testid="why-overline">{t.why.overline}</span>
          <h2 className="font-serif text-[34px] sm:text-[42px] lg:text-[52px] leading-[1.08] tracking-tight text-[var(--navy)] mt-6" data-testid="why-title">
            {t.why.title}
          </h2>
          <div className="mt-8 w-14 h-px bg-[var(--champagne)]" />
          <p className="mt-8 text-[16px] lg:text-[17px] leading-[1.85] text-[var(--charcoal)]" data-testid="why-p1">
            {t.why.p1}
          </p>
          <p className="mt-4 text-[16px] lg:text-[17px] leading-[1.85] text-[var(--charcoal)]" data-testid="why-p2">
            {t.why.p2}
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {t.why.cards.map((c, idx) => {
            const Icon = ICONS[idx];
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: idx * 0.1 }}
                className="bg-[var(--ivory-2)] p-10 border border-[var(--border-light)]"
                data-testid={`why-card-${idx}`}
              >
                <Icon className="w-7 h-7 text-[var(--champagne)]" strokeWidth={1.3} />
                <h3 className="font-serif text-[26px] lg:text-[30px] text-[var(--navy)] mt-6 leading-tight">
                  {c.title}
                </h3>
                <p className="mt-4 text-[15px] leading-[1.8] text-[var(--charcoal)]">
                  {c.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Why;
